import { Card, Col, ProgressBar, Row, Table, Button } from "react-bootstrap";
import ButtonLoad from 'react-bootstrap-button-loader';
import axios from "axios";
import { Link,useHistory,useNavigate} from "react-router-dom";
import React,{ useState,useRef ,useEffect} from "react";
import { BinanceLaunchpadGet, generateBillingInvoice, getInvoice, payBillingInvoice } from "../API/ApiFunctions";
import web3 from '../../web3';
import utils from 'web3';
import {dimeabi} from './dimeabi';
import { launchpadabi } from "./launchpadabi";
import { ethers } from "ethers";

const Dashboard = () => {

    const [firstName, setfirstName] = useState();
    const [emailAddress, setEmailAddress] = useState();
    const [userCredit,setCredits]=useState();
    const [generatedDate, setGeneratedDate] = useState();
    const [dueDate, setDueDate] = useState();
    const [currentOutstanding,setCurrentOutstanding] = useState();
    const [statusInvoice,setStatusInvoice] = useState();
    const [percent,setpercent]=useState();
    const [ genBill, setGenBill ] = useState(false);
    const [isconnected, setIsconnected] = useState(false);

//BinanceLaunchpad start
    const[pageBLSize,setPageBLSize]=useState(2);     

  const decrementBLSize=()=>{
    if(pageBLSize >= 4){
    setPageBLSize(pageBLSize-2)
    }        
  }
//BinanceLaunchpad end

//BinanceBond start
const[pageBBSize,setPageBBSize]=useState(2);     

const decrementBBSize=()=>{
  if(pageBBSize >= 4){
  setPageBBSize(pageBBSize-2)
  }        
}
//BinanceBond end

//AlgorandLaunchpad start
const[pageALSize,setPageALSize]=useState(2);     

const decrementALSize=()=>{
  if(pageALSize >= 4){
  setPageALSize(pageALSize-2)
  }        
}
//AlgorandLaunchpad end

//AlgorandBond start
const[pageABSize,setPageABSize]=useState(2);     

const decrementABSize=()=>{
  if(pageABSize >= 4){
  setPageABSize(pageABSize-2)
  }        
}
//AlgorandBond end


    const[datas,setdatas]=useState([""]);
    const[filtdata,setfiltdata]= useState([]);;
    const[filtdata3,setfiltdata3]= useState([]);
    const[filtdata2,setfiltdata2]= useState([]);
    // console.log("datasvalue",datas);
    const[values,setvalues]= useState([]);;
    const[Posts,setPosts]= useState();
    const[ad,setad]= useState();
    const[con,setcon]= useState();
    const[pagesCount,setpagesCount]= useState(0);
    const[pagesCountlist,setpagesCountlist]= useState("");
    const[binanceLaunchpadTable,setBinanceLaunchpadTable]= useState([]);
    const[binanceBondTable,setBinanceBondTable]= useState([]);
    const[algorandLaunchpadTable,setAlgorandLaunchpadTable]= useState([]);
    const[algorandBondTable,setAlgorandBondTable]= useState([]);
    console.log("binanceLaunchpadTable", binanceLaunchpadTable);
    const navigate = useNavigate();
  let key = "BvXlBA50Iw58XBSBZltS2H5P9IwS76f9hojA6aE5";
  useEffect(()=>{
    billingGet();
    get();
    percentage();
},[userCredit,emailAddress,firstName,percent,dueDate,generatedDate,currentOutstanding, genBill])
  const get = async () =>
  {
    let response2 = await fetch(`/platform/v1/userinfo`, 
    {
        headers: {
            'x-api-key': `${key}`    
          },
      }
      )
    //console.log(response2);
      const data2 = await response2.json();
    // console.log("fetch txhistory", {data2})
    if(localStorage.getItem('UserID') === null || localStorage.getItem('UserID') === undefined || localStorage.getItem('UserID') === ""){

     console.log("waiting to get local storage");
} 

else {
    for(let i=0;i<data2.length;i++){
        if(data2[i]['userId']===localStorage.getItem('UserID')){
            setEmailAddress(data2[i]['userId']);
            setfirstName(data2[i]['userName']);
            setCredits(data2[i]['userCredits'])
            break;
        }

    }
}
  }

  const billingGet = async () =>
  {
      const data = await getInvoice();
      const data2 = data['data2'];
    if(localStorage.getItem('UserID') === null || localStorage.getItem('UserID') === undefined || localStorage.getItem('UserID') === ""){

     console.log("waiting to get local storage");
} 

else {
            setGeneratedDate(data2['invoiceDate']);
            setDueDate(data2['dueDate']);
            setCurrentOutstanding(data2['billAmount']);
            setStatusInvoice(data2['status']);
}
  }

  const Logout = async () =>{
    localStorage.setItem("Login",false);
    localStorage.removeItem("Login");
    localStorage.removeItem("UserID");
    navigate('/Login');

  }
  
  const percentage = async () =>{
    let percalcredit=(parseFloat(userCredit)/2000)*100;
    setpercent(parseInt(percalcredit));
    console.log("percal",percalcredit)
  }

  useEffect(()=>{binanceLaunchpadTableFetch()},[])

  const binanceLaunchpadTableFetch=async()=>{            
    if(localStorage.getItem("UserID")  === null || localStorage.getItem("UserID")  === "" || localStorage.getItem("UserID")  === " " || localStorage.getItem("UserID") === undefined || localStorage.getItem("UserID") === ''){
    }
    else{
      let r=[];
      let countlist=0;
  try {          
      let data = await BinanceLaunchpadGet(localStorage.getItem("UserID"));
      console.log("Length", data['data2']['length']);     
      if (data['data2']) {  
          try{
          let datavar=data['data2'];
          console.log("datascheck1",datavar);
          Object.keys(datavar).map((m)=>{
            console.log("datascheck",datavar[m]);
            countlist=countlist + 1;
            if(datavar[m].networkType === "BL")
            {
            r.push({
              smartContractAddress:datavar[m].smartContractAddress,
              bondTokenAddress:datavar[m].bondTokenAddress,
              startDate:datavar[m].startDate,
              endDate:datavar[m].endDate,
            })  
            }              
          })       
      }   catch(e){                      
      } 
      r.reverse();
      setBinanceLaunchpadTable(r);                
      }
      else{
      setBinanceLaunchpadTable([""]);  
      }
      console.log("Data", data);
      //setpagesCountlist(countlist);        
  } catch (error) {            
  }                
  
}
  }

  useEffect(()=>{binanceBondTableFetch()},[])

  const binanceBondTableFetch=async()=>{            
    if(localStorage.getItem("UserID")  === null || localStorage.getItem("UserID")  === "" || localStorage.getItem("UserID")  === " " || localStorage.getItem("UserID") === undefined || localStorage.getItem("UserID") === ''){
    }
    else{
      let r=[];
      let countlist=0;
  try {          
      let data = await BinanceLaunchpadGet(localStorage.getItem("UserID"));
      console.log("Length", data['data2']['length']);     
      if (data['data2']) {  
          try{
          let datavar=data['data2'];
          console.log("datascheck1",datavar);
          Object.keys(datavar).map((m)=>{
            console.log("datascheck",datavar[m]);
            countlist=countlist + 1;
            if(datavar[m].networkType === "BB")
            {
            r.push({
              smartContractAddress:datavar[m].smartContractAddress,
              bondTokenAddress:datavar[m].bondTokenAddress,
              depositTokenAddress:datavar[m].depositTokenAddress,
            })  
            }              
          })       
      }   catch(e){                      
      } 
      r.reverse();
      setBinanceBondTable(r);                
      }
      else{
      setBinanceBondTable([""]);  
      }
      console.log("Data", data);
      //setpagesCountlist(countlist);        
  } catch (error) {            
  }                
  
}
  }

  useEffect(()=>{algorandLaunchpadTableFetch()},[])

  const algorandLaunchpadTableFetch=async()=>{            
    if(localStorage.getItem("UserID")  === null || localStorage.getItem("UserID")  === "" || localStorage.getItem("UserID")  === " " || localStorage.getItem("UserID") === undefined || localStorage.getItem("UserID") === ''){
    }
    else{
      let r=[];
      let countlist=0;
  try {          
      let data = await BinanceLaunchpadGet(localStorage.getItem("UserID"));
      console.log("Length", data['data2']['length']);     
      if (data['data2']) {  
          try{
          let datavar=data['data2'];
          console.log("datascheck1",datavar);
          Object.keys(datavar).map((m)=>{
            console.log("datascheck",datavar[m]);
            countlist=countlist + 1;
            if(datavar[m].networkType === "AL")
            {
            r.push({
              appId:datavar[m].appId,
              smartContractAddress:datavar[m].smartContractAddress,
              tokenName:datavar[m].tokenName,
              startDate:datavar[m].startDate,
              endDate:datavar[m].endDate,
            })  
            }              
          })       
      }   catch(e){                      
      } 
      r.reverse();
      setAlgorandLaunchpadTable(r);                
      }
      else{
        setAlgorandLaunchpadTable([""]);  
      }
      console.log("Data", data);
      //setpagesCountlist(countlist);        
  } catch (error) {            
  }                
  
}
  }

  useEffect(()=>{algorandBondTableFetch()},[])

  const algorandBondTableFetch=async()=>{            
    if(localStorage.getItem("UserID")  === null || localStorage.getItem("UserID")  === "" || localStorage.getItem("UserID")  === " " || localStorage.getItem("UserID") === undefined || localStorage.getItem("UserID") === ''){
    }
    else{
      let r=[];
      let countlist=0;
  try {          
      let data = await BinanceLaunchpadGet(localStorage.getItem("UserID"));
      console.log("Length", data['data2']['length']);     
      if (data['data2']) {  
          try{
          let datavar=data['data2'];
          console.log("datascheck1",datavar);
          Object.keys(datavar).map((m)=>{
            console.log("datascheck",datavar[m]);
            countlist=countlist + 1;
            if(datavar[m].networkType === "AB")
            {
            r.push({
              appId:datavar[m].appId,
              smartContractAddress:datavar[m].smartContractAddress,
              depositTokenAddress:datavar[m].depositTokenAddress,
              bondTokenAddress:datavar[m].bondTokenAddress,
            })  
            }              
          })       
      }   catch(e){                      
      } 
      r.reverse();
      setAlgorandBondTable(r);                
      }
      else{
        setAlgorandBondTable([""]);  
      }
      console.log("Data", data);
      //setpagesCountlist(countlist);        
  } catch (error) {            
  }                
  
}
  }

  const checkBill = async() =>
  {
    // let data = await generateBillingInvoice();
    // let data2 = data;
    // console.log("generateBill", data);
    setGenBill(true);
  }

  const payBill = async() =>
  {
    let data = await payBillingInvoice();
    // console.log("payBill", data);
  }

  const isMetaMaskInstalled = () => {
    //Have to check the ethereum binding on the window object to see if it's installed
    const { ethereum } = window;
    return Boolean(ethereum && ethereum.isMetaMask);
  };
//   const connectWallet=async()=>{    
 
//     var metamaskcheck= await isMetaMaskInstalled();
//    //  console.log(metamaskcheck);
//     if(metamaskcheck){
   
    
//      localStorage.setItem("walletName", "Metamask");             
//      const networkid=await web3.eth.getChainId();
//      console.log("network id",networkid);
//      if(networkid!=8453){
//      // setIsOpen(true);
//      // setDis("Connected to Wrong Network,Please connect to Binance Testnet");
//      }else{
   
     
//      window.ethereum.enable();  
     
//      const accounts =await web3.eth.getAccounts();
    
//        await web3.eth.getAccounts().then(()=>{          
//          console.log("acc Binance",accounts[0])
//          // setwalletconnect(accounts[0])
//          window.wallet=accounts[0];
//          localStorage.setItem("walletAddressSigma", accounts[0]);
//          // setShowButton(false);
       
//        }).then(()=>{
//            window.location.reload()
//        })
//      console.log(accounts);
//      }  
//    }else{  
//      window.open('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn', '_blank','noreferrer');
   
//    }
//    }

   const connectToEthereum = async () => {
    try {
        if (window.ethereum) {
            const ethProvider = new ethers.providers.Web3Provider(window.ethereum);
            return ethProvider;
        } else {
            throw new Error('No Ethereum wallet found.');
        }
    } catch (error) {
        console.error(error);
        return null;
    }
  };
  
  const switchToCorrectNetwork = async () => {
    try {
        const provider = await connectToEthereum();
        if (!provider) return;
  
        const network = await provider.getNetwork();
        const targetChainId = 8453;
  
        if (network.chainId !== targetChainId) {
          await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: "0x2105" }],
            });
            const signer = provider.getSigner();
        const currentAccount = await signer.getAddress();
        
        // setProvider(provider);
        // setAccount(currentAccount);
        localStorage.setItem("walletAddress", currentAccount)
        console.log("success",currentAccount);
        window.location.reload();
        }
    } catch (error) {
        console.error('Error switching network:', error);
    }
  };
  
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const ethProvider = new ethers.providers.Web3Provider(window.ethereum);
        const network = await ethProvider.getNetwork();
        console.log(network.chainId);
        if(network.chainId !== 8453){
            await switchToCorrectNetwork();
        }
        else{
            const signer = ethProvider.getSigner();
        const currentAccount = await signer.getAddress();
        console.log("adress",currentAccount)
        // setProvider(ethProvider);
        // setAccount(currentAccount);
        localStorage.setItem("walletAddress", currentAccount)
        console.log("success",currentAccount);
        window.location.reload();
        }
        
  
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
      }
    } else {
      console.error('MetaMask not detected.');
    }
  };

   useEffect(() =>{
        if(localStorage.getItem("walletAddressSigma") !== null && localStorage.getItem("walletAddressSigma") !== undefined && localStorage.getItem("walletAddressSigma") !== ""){
            setIsconnected(true);
        }
    
   },[]);

const approve = async() =>{
    try {
        // const web3 = await connectToEthereum();
        // if (!web3) return;
        // await connectWallet();

        const accounts =await web3.eth.getAccounts();

        const erc20token = new web3.eth.Contract(dimeabi, "0xB41EC7A7a09a950BDAD5f8f6Db515e14BCB11666");

        let approveresult = await erc20token.methods.approve('0x9c2E52b19C9dBE28f9097A96703B14DD31087f9a', web3.utils.toBN(10000000000000000000)).send({
            from: accounts[0],      
            //gas: 21000            
           })

        var allowance = web3.utils.toNumber(await erc20token.methods.allowance(localStorage.getItem("walletAddress"), '0x9c2E52b19C9dBE28f9097A96703B14DD31087f9a').call());
        console.log(allowance);
        const wallAddress = localStorage.getItem("walletAddress");
        localStorage.setItem(`${wallAddress}`, allowance);
        // setIsApproved(true);
        console.log("approved");
        console.log(approveresult.transactionHash);

        // await createActivityTable(localStorage.getItem("walletAddress"),"Launchpad Approve","0x19AcB98E4E2Ba4c39BDbEDE4706Cb37d4E0d4f18",approveresult.transactionHash,`Launchpad${number}`)
        // console.log("Data added to activity database!!");
    }
    catch (error) {
        console.error('Contract deployment error:', error);
      }
}

const connectToEthereum2 = async () => {
    try {
      if (window.ethereum) {
        let k = await window.ethereum.request({ method: 'eth_requestAccounts' });
        console.log("K",k)
        const web3= new ethers.providers.Web3Provider(window.ethereum);
        return k[0];
      } else {
        throw new Error('No Ethereum wallet found.');
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

const createNft =async() =>{
    try {
        // const web3 = await connectToEthereum();
        // if (!web3) return;
  
        // const accounts =await web3.eth.getAccounts();
        const web3 = await connectToEthereum();
        if (!web3) return;
  
        const account = localStorage.getItem("walletAddress");
  
        // let ipfsurl = "https://gateway.pinata.cloud/ipfs/QmdLCS6mfnfxvhy9TKZ7h3MCNAJ6y3piz2M7MKMhp2zvej?_gl=1*1p8csnr*rs_ga*OWNkNDU4MjktNDA4My00MzBlLTljMTktYmNkNjYyMDUyZDFk*rs_ga_5RMPXG14TE*MTY4MTg5MTIzMy41LjEuMTY4MTg5MTMwOC41Ny4wLjA.";
            //Normal NFT Mint
            const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
            console.log("signer",signer)
            const contractInstance = new ethers.Contract( "0x9c2E52b19C9dBE28f9097A96703B14DD31087f9a",launchpadabi, signer);
            const k = ethers.BigNumber.from("100000000000000000");
            let mintresult = await contractInstance.mintNFTWithTokens(
              k,
              "https://gateway.pinata.cloud/ipfs/QmdLCS6mfnfxvhy9TKZ7h3MCNAJ6y3piz2M7MKMhp2zvej?_gl=1*1p8csnr*rs_ga*OWNkNDU4MjktNDA4My00MzBlLTljMTktYmNkNjYyMDUyZDFk*rs_ga_5RMPXG14TE*MTY4MTg5MTIzMy41LjEuMTY4MTg5MTMwOC41Ny4wLjA."
            );
             //  let txhash =  await contractInstance.mint(web3);
           console.log("hashget",mintresult)
        // const contract = new web3.eth.Contract(abiLaunchpad);
  
        // const contractInstance = await contract
        //   .deploy({
        //     data: abibytecodeLaunchpad,
        //     arguments: ["Name","Matic","https://gateway.pinata.cloud/ipfs/QmdLCS6mfnfxvhy9TKZ7h3MCNAJ6y3piz2M7MKMhp2zvej?_gl=1*1p8csnr*rs_ga*OWNkNDU4MjktNDA4My00MzBlLTljMTktYmNkNjYyMDUyZDFk*rs_ga_5RMPXG14TE*MTY4MTg5MTIzMy41LjEuMTY4MTg5MTMwOC41Ny4wLjA.","0xf35A6D2F0f08638e6f09473Dd5f40e69b4889a8C"] ,
        //   })
        //   .send({
        //     from: account,
        //     gas: 15571390,
        //   });
        // console.log(contractInstance);
        // console.log('Contract deployed at address:', contractInstance.options.address);
        // setContractAddress(contractInstance.options.address);

        // console.log("deployed");
       
        //    const launchpad = new web3.eth.Contract(launchpadabi, '0x9c2E52b19C9dBE28f9097A96703B14DD31087f9a');
        // let mintresult = await launchpad.methods.mintNFTWithTokens(web3.utils.toBN(1000000000000000000),"https://gateway.pinata.cloud/ipfs/QmdLCS6mfnfxvhy9TKZ7h3MCNAJ6y3piz2M7MKMhp2zvej?_gl=1*1p8csnr*rs_ga*OWNkNDU4MjktNDA4My00MzBlLTljMTktYmNkNjYyMDUyZDFk*rs_ga_5RMPXG14TE*MTY4MTg5MTIzMy41LjEuMTY4MTg5MTMwOC41Ny4wLjA.").send({
        //     from: accounts[0],      
        //     //gas: 21000            
        //    })
        //    console.log("minted");

        // let tokenCount1 =   web3.utils.toNumber(await launchpad.methods.tokenCount().call());
        // let tokenLimit1 =   web3.utils.toNumber((await launchpad.methods.tokenLimit().call()));
        // console.log(tokenCount1);
        // console.log(tokenLimit1);
        // let mintPercent1 = ((tokenCount1*100)/tokenLimit1).toFixed(2);
        // localStorage.setItem(`tokenPercent${number}`,mintPercent1);
        // localStorage.setItem(`tokenCount${number}`,tokenCount1);
        // localStorage.setItem(`tokenLimit${number}`,tokenLimit1);
        // setTokenCount(localStorage.getItem(`tokenCount${number}`));
        // setTokenLimit(localStorage.getItem(`tokenLimit${number}`));
        // setMintPercent(localStorage.getItem(`tokenPercent${number}`));
        // console.log(mintPercent);
        // updateCurrentTime();
        // let txnTime = currentTime;
        // let Mintamount = `${count}`
        // console.log(mintresult.transactionHash);

        // await createLaunchpadTxnTable(txnTime,mintresult.transactionHash ,localStorage.getItem("walletAddress"),Mintamount,contractAddress,tokenCount1 );
        // console.log("Data added to launchpad database!!");

       
        // await createActivityTable(localStorage.getItem("walletAddress"),"Launchpad Mint",contractAddress,mintresult.transactionHash,`Launchpad${number}`)
        // console.log("Data added to activity database!!");

        // fun();
      } catch (error) {
        console.error('Contract deployment error:', error);
      }
}


    return (
        <div class="py-5">
            <div class="container">
                <Card className="card-dark mb-3">
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Launchpad </h5>
                        <a href="/" className="btn-link">Learn More</a>
                    </Card.Header>
                    <Card.Body className="px-3 text-center py-4">
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-2">Total Allocated: ${10000}</p>
                            {/* <p className="mb-2">Total balance: $2000</p> */}
                        </div>
                        <ProgressBar now={10} />
                    </Card.Body>
                </Card>

                <Row>
                    { !isconnected ? <>
                        {localStorage.getItem("walletAddress") === null || localStorage.getItem("walletAddress") === undefined || localStorage.getItem("walletAddress") === "" ?
                        (<>
                        <Col md={6} className="mb-4">
                    <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Connect Wallet</h5>
                            </Card.Header>
                            <Card.Body className="p-3">
                                    <br/><br/><br/>
                                    <ButtonLoad type="button" size="lg" className="w-100 btn-cta" onClick={() => connectWallet()}>Connect Wallet</ButtonLoad>
                                    <br/><br/><br/>
                            </Card.Body>
                        </Card>
                    </Col>
                        </>):(<>
                            <Col md={6} className="mb-4">
                        <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Details</h5>
                            </Card.Header>
                            <Card.Body className="p-3">
                                <p className="d-flex align-items-center justify-content-between">
                                    <strong>Account </strong>
                                    <span>{(localStorage.getItem("walletAddress")).substring(0, 4)}...{(localStorage.getItem("walletAddress")).substring((localStorage.getItem("walletAddress")).length -4, (localStorage.getItem("walletAddress")).length)}</span>
                                </p>
                                {/* <p className="d-flex align-items-center justify-content-between">
                                    <strong>User E-mail ID</strong>
                                    <span>{emailAddress}</span>
                                </p> */}
                                {/* <p className="d-flex align-items-center justify-content-between">
                                    <strong>Current outstanding</strong>
                                    <span>0.00</span>
                                </p> */}
                                <ButtonLoad type="button"  size="lg" className="w-100 btn-cta" onClick={()=>createNft()}>Participate</ButtonLoad>
                            </Card.Body>
                        </Card>
                    </Col>
                        </>)}
                    </> :
                    <>
                    <Col md={6} className="mb-4">
                    <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Billing Details</h5>
                            </Card.Header>
                            {genBill === false ? <>
                            <Card.Body className="p-3">
                                    <br/><br/><br/>
                                    <ButtonLoad type="button" size="lg" className="w-100 btn-cta" onClick={() => createNft()}>Participate</ButtonLoad>
                                    <br/><br/><br/>
                            </Card.Body>
                            </> : <>
                            <Card.Body className="p-3">
                                {statusInvoice === "PAID" ? <>
                                <p className="d-flex align-items-center justify-content-between">
                                    <strong>No pending invoices</strong>
                                </p>                    
                                   {/* <ButtonLoad disabled variant="success" type="button"  size="lg" className="w-100 btn-cta" >Paid</ButtonLoad> */}
                                </> : <>
                                <p className="d-flex align-items-center justify-content-between">
                                    <strong>Invoice date</strong>
                                    <span>{generatedDate}</span>
                                </p>
                                <p className="d-flex align-items-center justify-content-between">
                                    <strong>Due date</strong>
                                    <span>{dueDate}</span>
                                </p>
                                <p className="d-flex align-items-center justify-content-between">
                                    <strong>Current outstanding</strong>
                                    <span>{currentOutstanding}</span>
                                </p>
                                    <ButtonLoad type="button"  size="lg" className="w-100 btn-cta" onClick={() => payBill()}>Pay</ButtonLoad>
                                </>} 
                            </Card.Body>
                            </>}
                        </Card>
                    </Col></>}
                  
                    {/* <Col md={12} className="mb-4">
                        <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Binance Launchpad</h5>
                            </Card.Header>
                            <div className="overflow-auto" style={{maxHeight: '200px'}}>
                                <Table striped hover variant="dark" className="mb-0">
                                    <thead>
                                        <tr>
                                            <th width="35" className="text-center">#</th>
                                            <th>Contract address</th>
                                            <th>Token address</th>
                                            <th>Start date</th>
                                            <th>End date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {binanceLaunchpadTable.map((x,y)=>{
                                    if(y < pageBLSize)
                                    return(
                                        <tr>
                                        <td className="text-center">{y+1}</td>
                                        <td>{x.smartContractAddress}</td>
                                        <td>{x.bondTokenAddress}</td>
                                        <td>{x.startDate}</td>
                                        <td>{x.endDate}</td>
                                        </tr>
                                    )
                                    })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            {binanceLaunchpadTable <= 2 ? (
                                <></>
                            ):(
                                <div className='pagination justify-content-end d-flex align-items-center'>                                
                                <Button variant='page' onClick={()=>{decrementBLSize()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </Button>
                                <Button variant='page' onClick={()=>{setPageBLSize(pageBLSize+2)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </Button>
                            </div>
                      )}
                        </Card>                        
                    </Col> */}
                    {/* <Col md={12} className="mb-4">
                        <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Binance Bond</h5>
                            </Card.Header>
                            <div className="overflow-auto" style={{maxHeight: '200px'}}>
                                <Table striped hover variant="dark" className="mb-0">
                                    <thead>
                                        <tr>
                                            <th width="35" className="text-center">#</th>
                                            <th>Contract address</th>
                                            <th>Deposit token address</th>
                                            <th>Reward token address</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {binanceBondTable.map((x,y)=>{
                                    return(
                                        <tr>
                                        <td className="text-center">{y+1}</td>
                                        <td>{x.smartContractAddress}</td>
                                        <td>{x.depositTokenAddress}</td>
                                        <td>{x.bondTokenAddress}</td>
                                        </tr>
                                    )
                                    })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            {binanceBondTable <= 2 ? (
                                <></>
                            ):(
                                <div className='pagination justify-content-end d-flex align-items-center'>                                
                                <Button variant='page' onClick={()=>{decrementBBSize()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </Button>
                                <Button variant='page' onClick={()=>{setPageBBSize(pageBBSize+2)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </Button>
                            </div>
                      )}
                        </Card>
                    </Col>
                    <Col md={12} className="mb-4">
                        <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Algorand Launchpad</h5>
                            </Card.Header>
                            <div className="overflow-auto" style={{maxHeight: '200px'}}>
                                <Table striped hover variant="dark" className="mb-0">
                                    <thead>
                                        <tr>
                                            <th width="35" className="text-center">#</th>
                                            <th>App ID</th>
                                            <th>App address</th>
                                            <th>Asset ID</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {algorandLaunchpadTable.map((x,y)=>{
                                    return(
                                        <tr>
                                        <td className="text-center">{y+1}</td>
                                        <td>{x.appId}</td>
                                        <td>{x.smartContractAddress}</td>
                                        <td>{x.tokenName}</td>
                                        <td>{x.startDate}</td>
                                        <td>{x.endDate}</td>
                                        </tr>
                                    )
                                    })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            {algorandLaunchpadTable <= 2 ? (
                                <></>
                            ):(
                                <div className='pagination justify-content-end d-flex align-items-center'>                                
                                <Button variant='page' onClick={()=>{decrementALSize()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </Button>
                                <Button variant='page' onClick={()=>{setPageALSize(pageALSize+2)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </Button>
                            </div>
                      )}
                        </Card>
                    </Col> */}
                    {/* <Col md={12} className="mb-4">
                        <Card className="card-dark mb-3">
                            <Card.Header>
                                <h5 className="mb-0">Algorand Bond</h5>
                            </Card.Header>
                            <div className="overflow-auto" style={{maxHeight: '200px'}}>
                                <Table striped hover variant="dark" className="mb-0">
                                    <thead>
                                        <tr>
                                            <th width="35" className="text-center">#</th>
                                            <th>App ID</th>
                                            <th>App address</th>
                                            <th>Deposit Asset ID</th>
                                            <th>Reward Asset ID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {algorandBondTable.map((x,y)=>{
                                    return(
                                        <tr>
                                        <td className="text-center">{y+1}</td>
                                        <td>{x.smartContractAddress}</td>
                                        <td>{x.depositTokenAddress}</td>
                                        <td>{x.depositTokenAddress}</td>
                                        <td>{x.bondTokenAddress}</td>
                                        </tr>
                                    )
                                    })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            {algorandBondTable <= 2 ? (
                                <></>
                            ):(
                                <div className='pagination justify-content-end d-flex align-items-center'>                                
                                <Button variant='page' onClick={()=>{decrementABSize()}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                </Button>
                                <Button variant='page' onClick={()=>{setPageABSize(pageABSize+2)}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#fff" class="bi m-0 bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </Button>
                            </div>
                      )}
                        </Card>
                    </Col> */}
                </Row>
            </div>
        </div>
    );
  };
  
  export default Dashboard;